var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaystack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    "data-name": "logosandtypes com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #0ba4db;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H150V150H0V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.41,14.13H22.08c-3.57,0-6.48,2.94-6.48,6.53v11.76c0,3.59,2.92,6.53,6.48,6.53H127.09c3.57,0,6.48-2.94,6.48-6.53v-11.76c.32-3.59-2.59-6.53-6.16-6.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.41,79.79H22.08c-3.57,0-6.48,2.94-6.48,6.53v11.76c0,3.59,2.92,6.53,6.48,6.53H127.09c3.57,0,6.48-2.94,6.48-6.53v-11.76c.32-3.59-2.59-6.53-6.16-6.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.39,112.78H22.08c-3.57,0-6.48,2.94-6.48,6.53v11.76c0,3.59,2.92,6.53,6.48,6.53h59.31c3.57,0,6.48-2.94,6.48-6.53v-11.76c0-3.59-2.92-6.53-6.48-6.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.9,47.12H22.08c-3.57,0-6.48,2.94-6.48,6.53v11.76c0,3.59,2.92,6.53,6.48,6.53h111.81c3.57,0,6.48-2.94,6.48-6.53v-11.76c0-3.59-2.92-6.53-6.48-6.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.ff39605c9b649d7b5eb06b8c7232ce71.svg";
export { ForwardRef as ReactComponent };